package songwritersnotebook.app.screens.components

import songwritersnotebook.app.screens.*

import androidx.compose.animation.core.*
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.alpha
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.text.TextLayoutResult
import androidx.compose.ui.unit.IntOffset
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import songwritersnotebook.app.data.UserPresence
import kotlin.math.roundToInt

@Composable
fun RemoteCursorsOverlay(
    remotePresences: List<UserPresence>,
    textLayoutResult: TextLayoutResult?,
    modifier: Modifier = Modifier
) {
    if (textLayoutResult == null || remotePresences.isEmpty()) return

    val density = LocalDensity.current

    Box(modifier = modifier.fillMaxSize()) {
        remotePresences.forEach { presence ->
            val offset = presence.cursorPosition
            // Ensure cursor position is valid for current text
            val safeOffset = offset.coerceIn(0, textLayoutResult.layoutInput.text.length)
            
            val cursorRect = textLayoutResult.getCursorRect(safeOffset)
            val color = Color(if (presence.color != 0) presence.color else songwritersnotebook.app.data.UserPresence.generateUserColor(presence.userId))
            
            // Cursor Line with blinking animation
            val infiniteTransition = rememberInfiniteTransition()
            val alpha by infiniteTransition.animateFloat(
                initialValue = 1f,
                targetValue = 0.3f,
                animationSpec = infiniteRepeatable(
                    animation = tween(800),
                    repeatMode = RepeatMode.Reverse
                )
            )

            // Vertical Cursor Bar
            Box(
                modifier = Modifier
                    .offset { 
                        IntOffset(
                            x = cursorRect.left.roundToInt(),
                            y = cursorRect.top.roundToInt()
                        )
                    }
                    .width(2.dp)
                    .height(with(density) { (cursorRect.bottom - cursorRect.top).toDp() })
                    .background(color)
                    .alpha(alpha)
            )

            // Name Badge (Minimal: Just the initial)
            Box(
                modifier = Modifier
                    .offset {
                        IntOffset(
                            x = cursorRect.left.roundToInt(),
                            y = (cursorRect.top - with(density) { 16.dp.toPx() }).roundToInt()
                        )
                    }
                    .background(
                        color = color,
                        shape = RoundedCornerShape(topStart = 4.dp, topEnd = 4.dp, bottomEnd = 4.dp, bottomStart = 0.dp)
                    )
                    .padding(horizontal = 4.dp, vertical = 0.dp)
            ) {
                val identifier = when {
                    presence.email.isNotBlank() -> presence.email
                    presence.username.isNotBlank() -> presence.username
                    else -> "?"
                }
                val initial = identifier.trim().take(1).uppercase()

                val isWeb = songwritersnotebook.app.getPlatform().name.contains("Web", ignoreCase = true)
                val textModifier = if (isWeb) Modifier.offset(y = (-1).dp) else Modifier

                Text(
                    text = initial,
                    color = Color.White,
                    fontSize = 10.sp,
                    fontWeight = androidx.compose.ui.text.font.FontWeight.Bold,
                    maxLines = 1,
                    modifier = textModifier
                )
            }
        }
    }
}
